export enum ServerType {
    All = -1,
    Run = 1,
    Editor = 2    
}